import NotificationView from 'src/sections/management/notification/view/notification-view';

export default function Notification() {
  return <NotificationView />;
}
